import { gql } from "@apollo/client";

export const Login = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
    }
  }
`;

export const DuoLogin = gql`
  mutation DuoLogin($input: LoginInput!) {
    duoLogin(input: $input) {
      duoUrl
    }
  }
`;

export const PostDuoLogin = gql`
  mutation PostDuoLogin($input: PostDuoLoginInput!) {
    postDuoLogin(input: $input) {
      token
    }
  }
`;

export const ForgotPassword = gql`
  mutation ForgotPassword($email: String!) {
    sendForgotPasswordEmail(email: $email) {
      success
    }
  }
`;

export const ResetPassword = gql`
  mutation ResetPassword($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword) {
      token
      duoUrl
    }
  }
`;

export const GetRole = gql`
  query GetRole {
    me {
      role
    }
  }
`;

export const GetAdminId = gql`
  query {
    me {
      id
    }
  }
`;

export const ChangeRole = gql`
  mutation ChangeRole($input: ChangeRoleInput!) {
    changeRole(input: $input) {
      success
    }
  }
`;

export const DeleteUser = gql`
  mutation DeleteUser($input: UserInput!) {
    deleteParticipant(input: $input) {
      success
    }
  }
`;

export const DeleteNonPartcipant = gql`
  mutation DeleteNonPartcipant($input: UserInput!) {
    deleteNonParticipant(input: $input) {
      success
    }
  }
`;

export const ForceResetPassword = gql`
  mutation ForceResetPassword($id: String!) {
    forceResetPassword(id: $id) {
      success
    }
  }
`;

export const ChangeOrganization = gql`
  mutation ChangeOrganization($input: ChangeOrgInput!) {
    changeOrganization(input: $input) {
      success
    }
  }
`;

export const ToggleUserActive = gql`
  mutation ToggleUserActive($input: ToggleUserActiveInput!) {
    toggleUserActive(input: $input) {
      success
    }
  }
`;

export const LoginAsUser = gql`
  mutation LoginAsUser($input: LoginAsUserInput!) {
    loginAsUser(input: $input) {
      loginLink
    }
  }
`;

export const UnlockAllTrainingForUser = gql`
  mutation UnlockAllTrainingForUser($id: String!) {
    unlockAllTrainingForUser(id: $id) {
      success
    }
  }
`;

export const ResetTraining = gql`
  mutation resetTrainingForUser($id: String!) {
    resetTrainingForUser(id: $id) {
      success
    }
  }
`;
